/**
 *Created by jmmartinez on 3/8/18
 **/

import React from 'react'
import connect from "react-redux/es/connect/connect";
import './resources/css/layout.css';
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";

import Content from "./Content"
import {estadoChangePagina} from './redux/estado/actions'
import {encabezado} from "./Configuracion";
import {obtenerSedeCodigo} from "./utils/WindowUtils";


class Main extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        let sedeCodigo= obtenerSedeCodigo();
        let terminalWebCodigo= sedeCodigo;
        console.log("XXXX MAIN: sedeCodigo: ", sedeCodigo, " terminalWebCodigo:", terminalWebCodigo);

        this.setState({sedeCodigo: sedeCodigo, terminalWebCodigo: terminalWebCodigo});
    }

    click = (paginaId) => {
        this.props.dispatch(estadoChangePagina(paginaId));
    }

    render() {
        const {sedeCodigo, terminalWebCodigo} = this.state;

        let classAppHeader= "App-header";
        let classAppHeaderTitulo= "App-header-titulo";
        let componenteImg= null;
        switch (encabezado){
            case "Matrimur":
                classAppHeader= "App-header_Matrimur";
                componenteImg= <img src={require('./resources/images/logo_matrimur.jpg')} width={294} alt={"logo"}/>;
                break;
            case "CabezoFP":
                classAppHeader= "App-header_CabezoFP";
                componenteImg= <img src={require('./resources/images/logo_cabezofp.jpg')} width={294} alt={"logo"}/>;
                break;
            case "ClinicaAlaquas":
                classAppHeader= "App-header_ClinicaAlaquas";
                classAppHeaderTitulo= "App-header-titulo_ClinicaAlaquas";
                if (sedeCodigo== 1)
                    componenteImg= <img src={require('./resources/images/logo_clinicaalaquas.png')} height={70} alt={"logo"}/>;
                else
                    componenteImg= <img src={require('./resources/images/logo_clinicamassanassa.png')} height={70} alt={"logo"}/>;
                break;
            case "CarniceriaPeris":
                classAppHeader= "App-header_CarniceriaPeris";
                classAppHeaderTitulo= "App-header-titulo_CarniceriaPeris";
                componenteImg= <img src={require('./resources/images/logo_peris.jpg')} height={70} alt={"logo"}/>;
                break;
            case "EnvasesBeniajan":
                classAppHeader= "App-header_EnvasesBeniajan";
                classAppHeaderTitulo= "App-header-titulo_EnvasesBeniajan";
                componenteImg= <img src={require('./resources/images/logo_envases.png')} height={65} alt={"logo"}/>;
                break;
            case "Tecnica":
                componenteImg= <img src={require('./resources/images/logo_tecnica.jpg')} width={294} alt={"logo"}/>;
                break;
        }


        return (
        <div className="App">
            <header className={classAppHeader}>
                <div className="App-header-logo"> {componenteImg} </div>
                <div className={classAppHeaderTitulo}>
                            EJ2 CONTROL PRESENCIAL
                </div>
            </header>
            <Content sedeCodigo={sedeCodigo} terminalWebCodigo={terminalWebCodigo}/>

        </div>
        );
    }
}


const mapStateToProps = function(state) {
    return {

    }
}

export default connect(mapStateToProps)(Main);

